__turbopack_context__.v({
  "emptyCatalog": "catalog-empty-module-scss-module__r8L1tG__emptyCatalog",
});
